<template>
  <v-app>
    <Sidebar />
    <v-main>
      <v-container :fluid="$vuetify.breakpoint.width <= 1920">
        <router-view></router-view>
      </v-container>
    </v-main>
    <BottomNavigation />
  </v-app>
</template>

<script>
import Sidebar from "@/components/Sidebar";
import BottomNavigation from "@/components/BottomNavigation";

export default {
  name: "App",

  components: {
    Sidebar,
    BottomNavigation
  },

  data: () => ({
    //
  })
};
</script>

<style>
main {
  background-color: rgba(25, 25, 25, 1);
}
.unselectable {
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  -o-user-select: none;
  user-select: none;
}
</style>